import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["ai-marketing"]!.fr;

export const Route = createFileRoute("/services/ai-marketing")({
  head: () =>
    pageHead({
      path: "/services/ai-marketing",
      title: c.title,
      description: c.description,
      crumbs: [["Services", "/services"], ["IA & Agentic Marketing", "/services/ai-marketing"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="ai-marketing" />,
});
